import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-maintenance',
  imports: [LucideAngularModule],
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent {}
